import * as React from "react"
import {Drawer} from "@mui/material";

import {SimpleScrollbar} from "..";
import {navWidth, openMenu} from "../../@signals";


export default function AppMobileNavDrawer({ children, scrollbarProps={}, ...props }) {

    return <Drawer
        open={openMenu.value}
        onClose={() => openMenu.value = false}
        {...props}
        ModalProps={{
            keepMounted: true,
            ...props?.ModalProps
        }}
        PaperProps={{
            ...props?.PaperProps,
            sx: {
                width: navWidth.value,
                ...props?.PaperProps?.sx,
            }
        }}
    >
        <SimpleScrollbar {...scrollbarProps}>
            {children}
        </SimpleScrollbar>
    </Drawer>
}